import React from 'react';
import * as S from './style';
import { FormStatusInfo, Btn } from 'components';
import { ReactComponent as ImgApproveCheck } from 'assets/img/status/img_approve_check.svg';
import { ReactComponent as CheckOn } from 'assets/img/common/btn_checkbox_on.svg';
import { ReactComponent as CheckOff } from 'assets/img/common/btn_checkbox_off.svg';
import { ReactComponent as GrayArrow } from 'assets/img/common/ic_right_arrow_gray.svg';
import { ReactComponent as BlueArrow } from 'assets/img/common/ic_right_arrow_blue.svg';

interface Props {
    isApproveCheck: boolean;
    isActive?: boolean;
    buttons?: Array<{ name: string; onClick: () => void; checked: boolean }>;
    onClickApproveCheck: () => void;
}

function InterviewApprove({ isActive, isApproveCheck, buttons, onClickApproveCheck }: Props): React.ReactElement {
    return (
        <FormStatusInfo
            title={['환영합니다!']}
            subTitle={['짐싸 파트너에 승인되었습니다.']}
            image={<ImgApproveCheck />}
            btn={
                <Btn
                    height={64}
                    fontStyle={'body1_bold'}
                    backGroundColor={isActive && !isApproveCheck ? 'blue_900' : 'gray_opacity_200'}
                    color={isActive && !isApproveCheck ? 'gray_opacity_50' : 'gray_opacity_300'}
                    onClick={isActive && !isApproveCheck ? onClickApproveCheck : () => {}}
                >
                    {isApproveCheck ? '최종승인 심사중입니다.' : '최종승인 신청'}
                </Btn>
            }
            inHomeBtn={true}
        >
            <S.CaptionWrapper>
                짐싸는 투명한 시스템을 바탕으로, 공급/수요에 맞추어 서비스를 만들어 나가고 있습니다. 다음 프로필 등록을 완료하시어 짐싸 파트너로 활동하세요!
                <br />
                아래의 버튼을 눌러 절차를 진행해주세요.
            </S.CaptionWrapper>
            <S.BtnInterviewWrapper>
                {buttons?.map((item, index) => (
                    <Btn
                        key={index}
                        backGroundColor={'gray_opacity_50'}
                        boarderColor={item.checked ? 'blue_900' : 'gray_opacity_200'}
                        color={item.checked ? 'blue_900' : 'gray_opacity_600'}
                        fontStyle={'body2'}
                        height={52}
                        onClick={item.onClick}
                    >
                        <S.BtnContentsContainer>
                            <S.BtnContentsWrapper>
                                {item.checked ? <CheckOn /> : <CheckOff />} {item.name}
                            </S.BtnContentsWrapper>
                            {item.checked ? <BlueArrow /> : <GrayArrow />}
                        </S.BtnContentsContainer>
                    </Btn>
                ))}
            </S.BtnInterviewWrapper>
        </FormStatusInfo>
    );
}

export default InterviewApprove;
